import type { OrderStore } from './interfaces'

export const getters = {
  getOrder: (state: OrderStore): OrderStore['order'] => state.order,
  hasOrder: (state: OrderStore): boolean => !!state.order,
  getChangelogPayment: (state: OrderStore): OrderStore['changelogPayment'] => state.changelogPayment,
}
